import { useMemo } from 'react'
import { objType } from 'types';

const useGetPath = (val: objType) => {

    const path = useMemo(() => {

        const appId = !!val.lesson_id ? val.lesson_id : !!val.uid ? `${ val.uid }` : '';

        if ( !!appId ) {
            let path = appId.replaceAll(' ','_');
            if (path[path.length - 1] === '?') {
                path = path.slice(0, path.length - 1);
            }
            return `${ path }`
        } 
        return '/'
    },[val])

    return path

}

export default useGetPath
